
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-tools/logistics-explorer",
      function () {
        return require("private-next-pages/digital-tools/logistics-explorer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-tools/logistics-explorer"])
      });
    }
  